import { render, staticRenderFns } from "./CreateAccountPage.vue?vue&type=template&id=2941187a&scoped=true"
import script from "./CreateAccountPage.vue?vue&type=script&lang=js"
export * from "./CreateAccountPage.vue?vue&type=script&lang=js"
import style0 from "./CreateAccountPage.vue?vue&type=style&index=0&id=2941187a&prod&lang=stylus&scoped=true"
import style1 from "./CreateAccountPage.vue?vue&type=style&index=1&id=2941187a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2941187a",
  null
  
)

export default component.exports